import { render, staticRenderFns } from "./TabSample.vue?vue&type=template&id=7934ded6&"
import script from "./TabSample.vue?vue&type=script&lang=js&"
export * from "./TabSample.vue?vue&type=script&lang=js&"
import style0 from "./TabSample.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports